<template>
  <div
    class="modal"
    style="display:block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span>Add a Start Trigger</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Select new trigger</label>
                <select
                  v-model="models.id"
                  class="form-control"
                >
                  <option
                    v-for="(trigger, idx) in triggers"
                    :key="idx"
                    :value="trigger.id"
                  >
                    {{ trigger.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-success"
            @click="add()"
          >
            Create
          </button>
          <button
            class="btn btn-danger"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCreateTrigger',
  data: () => (
    {
      triggers: [
        {
          id: 1,
          name: 'subscribe',
          text: 'Subscribes to a list'
        },
        {
          id: 2,
          name: 'unsubscribe',
          text: 'Unsubscribes from a list'
        }
      ],
      models: {
        id: 1
      }
    }
  ),
  methods: {
    add() {
      const data = this.triggers.find(t => t.id === this.models.id)

      this.$emit('add', {
        ...data
      })
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  &-header {
    span {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalCreateTrigger.vue